import React from 'react';
import {
  Button, Col, Heading, Row,
} from 'idsk-react-components';
import './modalNavigationGuard.scss';

type ModalProps = {
  visible?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  headingModal: string;
  contentModal: string;
};

const ModalNavigationGuard: React.FC<ModalProps> = ({
  visible = false, onCancel, onConfirm, headingModal, contentModal,
}: ModalProps) => {
  const confirm = (): void => {
    onCancel();
    onConfirm();
  };

  return (
    <>
      {visible && (
        <div className="modal-dialogue-overlay">
          <div className="modal-dialogue">
            <div className="modal-container">
              <div className="bg-modal" />
              <div className="modal-dialogue-window default">
                <div className="modal-dialogue-window__top-bar default">
                  <button
                    className="modal-dialogue-window-buton--close"
                    type="button"
                    onClick={onCancel}
                  >
                    &#8203;
                  </button>
                </div>
                <Heading className="modal-dialogue-window__header" aria-label="Modal dialogue title" size="l">
                  {headingModal}
                </Heading>
                <div className="modal-dialogue-window__content" aria-label="Modal dialogue content">
                  {contentModal}
                </div>
                <div className="modal-dialogue-window__footer">
                  <Row className="buttons">
                    <Col>
                      <Button onClick={confirm} type="button" size="large">
                        Áno
                      </Button>
                      <Button
                        className="cancel-action"
                        buttonStyle="link"
                        size="small"
                        onClick={() => onCancel()}
                        type="button"
                      >
                        Nie
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalNavigationGuard;
